import { render, staticRenderFns } from "./DebitNoteAdd.vue?vue&type=template&id=4c85b976&scoped=true"
import script from "./DebitNoteAdd.vue?vue&type=script&lang=js"
export * from "./DebitNoteAdd.vue?vue&type=script&lang=js"
import style0 from "./DebitNoteAdd.vue?vue&type=style&index=0&id=4c85b976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85b976",
  null
  
)

export default component.exports